"use client"

import { BlockchainsMoleculeReatom as BlockchainsMolecule } from "@/app/blockchains/blockchain-molecule.reatom"
import { reatomComponent } from "@reatom/react"
import { useMolecule } from "bunshi/react"
import { useCollectionBlockchain } from "../../store/use-collection"
import { EvmModernSellDialogContent } from "./evm-modern-dialog-content"
import { SolanaModernSellDialogContent } from "./solana-modern-dialog-content.reatom"

interface Props {
  isMultiple?: boolean
}

export const SellDialogContent = reatomComponent(({ isMultiple }: Props) => {
  const blockchain = useCollectionBlockchain()
  const { reatomIsEvmBlockchain, reatomIsSolanaBlockchain } =
    useMolecule(BlockchainsMolecule)
  const isEvmBlockchain = reatomIsEvmBlockchain()(blockchain)
  const isSolanaBlockchain = reatomIsSolanaBlockchain()(blockchain)
  //@todo refactor fees later

  if (isEvmBlockchain) {
    return <EvmModernSellDialogContent isMultiple={isMultiple} />
  }

  if (isSolanaBlockchain) {
    return <SolanaModernSellDialogContent isMultiple={isMultiple} />
  }
}, "SellDialogContent")
